module.exports = __webpack_public_path__ + "img/service1.6c058221.png";